import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteCreditDispensation from 'hooks/creditDispensation/useDeleteCreditDispensation';
import { CreditDispensation } from 'types';
import notificationHandler from 'utils/notifications';

interface IModalCreditDispensationDelete {
  opened: boolean;
  handleClose: () => void;
  creditDispensation: CreditDispensation | null;
}

const ModalCreditDispensationDelete = ({
  opened,
  creditDispensation,
  handleClose,
}: IModalCreditDispensationDelete): JSX.Element => {
  const deleteMutation = useDeleteCreditDispensation();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    if (creditDispensation) {
      deleteMutation.mutate(creditDispensation.creditDispensationId, {
        onSuccess: () => {
          successNotification(
            'Credit Dispensation delete success',
            `Credit Dispensation successfully deleted.`,
          );
          handleClose();
        },
        onError: error => {
          errorNotification('Credit Dispensation delete failed', error.response?.data.message);
        },
      });
    }
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Credit Dispensation</Title>}
      size='auto'
    >
      <Stack>
        <Text>Are you sure you want to delete this credit dispensation?</Text>
        <Text color='dimmed'>
          This action cannot be undone. It will delete this credit dispensation for this package.
        </Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={deleteMutation.isLoading}
            data-cy='submitDeleteCreditDispensationButton'
            disabled={creditDispensation?.hasRolledOver}
          >
            Submit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalCreditDispensationDelete;
